import { createAsyncAction } from 'typesafe-actions'
import { UserState } from '../../types'
import { Failure, Request, Success } from './types'

export const updateUserOnMainApiAction = createAsyncAction(
  '@user/UPDATE_USER_ON_MAIN_API_REQUEST',
  '@user/UPDATE_USER_ON_MAIN_API_SUCCESS',
  '@user/UPDATE_USER_ON_MAIN_API_FAILURE'
)<Request, Success, Failure>()

const request = (state: UserState): UserState => ({
  ...state,
  isLoadingUpdateUserOnMainApi: true,
  isErrorOnUpdateUserOnMainApi: false,
  isSuccessOnUpdateUserOnMainApi: false
})

const success = (state: UserState): UserState => ({
  ...state,
  isLoadingUpdateUserOnMainApi: false,
  isErrorOnUpdateUserOnMainApi: false,
  isSuccessOnUpdateUserOnMainApi: true
})

const failure = (state: UserState): UserState => ({
  ...state,
  isLoadingUpdateUserOnMainApi: false,
  isSuccessOnUpdateUserOnMainApi: false,
  isErrorOnUpdateUserOnMainApi: true
})

export const updateUserOnMainApiHandle = { asyncAction: updateUserOnMainApiAction, request, success, failure }
